import React from 'react';

interface PageTitle {
	text: React.ReactNode;
	type?: string;
}

const PageTitle = ({ text }: PageTitle) => {
	return (
		<div className="flex items-center gap-2">
			<h1 className="break-words text-xl font-bold leading-tight text-dark md:text-2xl">
				{text}
			</h1>
		</div>
	);
};

export { PageTitle };
